// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'
import { cacher } from "../rtkQueryCacheUtils";

// Define a service using a base URL and expected endpoints
export const objectModelsApi = createApi({
  reducerPath: 'objectModelsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.objectsApiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: [...cacher.defaultTags, 'MODELS'],
  endpoints: (builder) => ({
    getModels: builder.query<any[], void>({
      query: () => ({
        url: `/models`,
        method: 'get'
      }),
      providesTags: cacher.providesList("MODELS")
    }),
    getModelById: builder.query<any[], string>({
      query: (arg) => ({
        url: `/models/${encodeURIComponent(arg)}/DtdlModel?recursive`,
        method: 'get'
      }),
      providesTags: (result, error, arg) => [{ type: 'MODELS', arg }],
    })
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetModelsQuery,
  useGetModelByIdQuery
} = objectModelsApi